import { useState } from 'react';
import {
    DndContext,
    
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
    DragEndEvent,
    DragStartEvent,
} from '@dnd-kit/core';
import {
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';

interface UseSortableListOptions {
    onReorder: (activeId: string, overId: string) => void;
    strategy?: typeof verticalListSortingStrategy;
}

export function useSortableList(
    items: Array<{ id: string }>,
    options: UseSortableListOptions
) {
    const [activeId, setActiveId] = useState<string | null>(null);

    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 8, // Require 8px movement before drag starts
            },
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const handleDragStart = (event: DragStartEvent) => {
        setActiveId(event.active.id as string);
    };

    const handleDragEnd = (event: DragEndEvent) => {
        const { active, over } = event;

        if (over && active.id !== over.id) {
            options.onReorder(active.id as string, over.id as string);
        }

        setActiveId(null);
    };

    const handleDragCancel = () => {
        setActiveId(null);
    };

    return {
        sensors,
        activeId,
        handleDragStart,
        handleDragEnd,
        handleDragCancel,
        DndContext,
        SortableContext,
        strategy: options.strategy || verticalListSortingStrategy,
        itemIds: items.map(item => item.id),
    };
}














